export function rejectPayNowIfNoPaymentMethodsReceived(data) {
  if (data?.mdr_flag) {
    return (
      !data?.payment_options_with_txn_charge?.payment_modes &&
      !data?.payment_options_with_txn_charge?.others
    );
  }
  return !data?.payment_modes && !data?.others;
}
